import { Component, Input } from '@angular/core';
import { SelectOption } from "./model/select-option";
import { InputWrapperComponent } from "../input-wrapper/input-wrapper.component";

@Component({
  selector: 'psc-select',
  templateUrl: './select.component.html',
})
export class SelectComponent extends InputWrapperComponent<string> {

  @Input() options: SelectOption[] = [];
  @Input() placeholder: string;
  @Input() loading: boolean;

}
